// extracted by mini-css-extract-plugin
export var container = "styles-module__container___rQlTP";
export var image = "styles-module__image___f6qW_";
export var subtext = "styles-module__subtext___OvvLt";
export var title = "styles-module__title___kLkaF";